import { Field, useFormikContext } from "formik";
import get from "lodash/get";

const INTEGER = "Integer";
const FLOAT = "Float";
const DECIMAL = "Decimal";
const dataTypeLimit = {
  Integer: { min: -2147483648, max: 2147483647 },
  Float: { min: -9007199254740993, max: 9007199254740992 },
  Decimal: { min: Number.NEGATIVE_INFINITY, max: Number.POSITIVE_INFINITY },
};
const blockedChar = ["e", "E", "+"];

const NumberField = ({
  value,
  name,
  label,
  handleBlur,
  handleChange,
  options,
  disabled,
  type,
  shouldUpdateType = false,
}) => {
  const { errors, touched } = useFormikContext();
  const getPattern = (type) => {
    switch (type) {
      case INTEGER:
        return "[0-9]+";
      case FLOAT:
        return "[+-]?([0-9]*[.])?[0-9]+";
      case DECIMAL:
        return "[0-9]+.[0-9]+";
      default:
        return;
    }
  };

  const blockInvalidChar = (e) =>
    blockedChar.includes(e.key) && e.preventDefault();

  return (
    <div className="form-group">
      {shouldUpdateType && (
        <>
          <label className="text-sm font-medium text-gray-50 mb-1 block capitalize">
            Numeric Data Type
          </label>
          <Field
            as="select"
            name="schema.type"
            onChange={handleChange}
            onBlur={handleBlur}
            className="w-full bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:text-gray-900 mb-3"
            disabled={disabled}
          >
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Field>
        </>
      )}
      <label className="text-sm font-medium text-gray-50 mb-1 block">
        {label}
      </label>
      <Field
        type="number"
        step="any"
        pattern={getPattern(type)}
        name={name}
        className="form-control"
        placeholder={label}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        min={dataTypeLimit[type].min}
        max={dataTypeLimit[type].max}
        onKeyDown={blockInvalidChar}
      />
      {get(errors, name, false) && get(touched, name, false) && (
        <div
          className="text-sm font-medium text-red-500"
          data-testid="name-error"
        >
          {get(errors, name, false)}
        </div>
      )}
    </div>
  );
};
export default NumberField;
